import classNames from "classnames";
import { LiveGameTime } from "./LiveGameTime";

export function LiveGameWinCondition({ leftSide, data }) {
    if (!data) return null;

    const wonder_icon = '/liveGameIcons/victory_condition/wonder.png';
    const religious_icon = '/liveGameIcons/victory_condition/religious.png';
    const conquest_icon = '/liveGameIcons/victory_condition/conquest.png';

    return (
        <>
            {data.wonder_timer !== 0 && winCondition({ leftSide, data, type: "wonder", icon: wonder_icon })}
            {data.sacred_site_timer !== 0 && winCondition({ leftSide, data, type: "religious", icon: religious_icon })}
            {data.enemy_landmark_destroyed !== 0 && winCondition({ leftSide, data, type: "conquest", icon: conquest_icon })}
        </>
    )
}

function winCondition({ leftSide, data, icon, type }) {
    return (
        <div className={classNames('liveGameWinCondition px-2 h-[48px] flex', leftSide ? 'flex-row' : 'flex-row-reverse')} style={{ flex: '0 0 auto', background: 'linear-gradient(90deg,rgba(29, 39, 47, 0.0) 0%, rgba(29, 39, 47, 1) 10%, rgba(29, 39, 47, 1) 90%, rgba(29, 39, 47, 0.0) 100%)' }}>
            <div className="mt-[2px] mx-[7px]">
                <img src={icon} className='w-11' alt={``} />
            </div>
            <div className={classNames('text-white italic text-lg')}>
                <div className="h-5">
                    {type === "wonder" && <span>Wonder Victory</span>}
                    {type === "religious" && <span>Sacred Victory</span>}
                    {type === "conquest" && <span>Elimination Victory</span>}
                </div>
                <div className={classNames("h-5 flex overflow-hidden", leftSide ? 'justify-start' : 'justify-end')}>
                    {type === "wonder" && <span className="flex flex-row"><LiveGameTime time={data.wonder_timer} /></span>}
                    {type === "religious" && <span className="flex flex-row"><LiveGameTime time={data.sacred_site_timer} /></span>}
                    {type === "conquest" && <span>{data.enemy_landmark_destroyed}/{data.enemy_landmark_built}</span>}
                </div>
            </div>
        </div>
    )
}